// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const usefulLifeRevisionReasonSchema = z.enum([
  'REASSESSMENT',
  'REFURBISHMENT',
  'CHANGE_IN_USE',
  'OBSOLESCENCE',
  'DAMAGE',
  'REGULATORY',
  'OTHER',
]);

export type UsefulLifeRevisionReason = z.infer<
  typeof usefulLifeRevisionReasonSchema
>;

export const USEFUL_LIFE_REVISION_REASON_LABELS: Record<
  UsefulLifeRevisionReason,
  string
> = {
  REASSESSMENT: 'Reassessment',
  REFURBISHMENT: 'Refurbishment',
  CHANGE_IN_USE: 'Change in use',
  OBSOLESCENCE: 'Obsolescence',
  DAMAGE: 'Damage',
  REGULATORY: 'Regulatory',
  OTHER: 'Other',
};

export const USEFUL_LIFE_REVISION_REASON_OPTIONS =
  usefulLifeRevisionReasonSchema.options.map((reason) => ({
    value: reason,
    label: USEFUL_LIFE_REVISION_REASON_LABELS[reason],
  }));
